import { User } from '../interfaces/User';

export class GroupRequestModel {
  recaptchaToken: string;
  requestType: string;
  contact: {
    agencyName: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    message: string;
  };
  hotelRequest: {
    destination: string;
    hotelName: string;
    stars: number;
    numberOfRooms: string;
    checkIn?: string;
    checkOut?: string;
    roomType?: string;
    groupType: string;
  };
  flightRequest: {
    from: string;
    to: string;
    airline: string;
    date?: string;
    flightTime: string;
    numberOfPassengers: string;
  };

  constructor(user?: User) {
    this.recaptchaToken = '';
    this.requestType = 'Hotel';
    this.contact = {
      agencyName: '',
      firstName: user?.username || '',
      lastName: '',
      phone: user?.phone || '',
      email: user?.email || '',
      message: '',
    };
    this.hotelRequest = {
      destination: '',
      hotelName: '',
      stars: 0,
      numberOfRooms: '',
      checkIn: undefined,
      checkOut: undefined,
      roomType: undefined,
      groupType: '',
    };
    this.flightRequest = {
      from: '',
      to: '',
      airline: '',
      date: undefined,
      flightTime: '',
      numberOfPassengers: '',
    };
  }
}
